<div id="race-title-box">
    <h1> {{ subType === "EVENT"? eventName : raceName}} </h1>
</div>
